import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { UiModule } from '@dcs-workspace/ui';
import { FormlyTextFieldComponent } from './formly-custom-fields/formly-text-field/formly-text-field.component';
import { FormlyModule } from '@ngx-formly/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { NavigationMenuModule } from './navigation-menu/navigation-menu.module';
import { DsValueAccessorDirective } from './utils/ds-value-accessor.directive';
import { FormlyDateFieldComponent } from './formly-custom-fields/formly-date-field/formly-date-field.component';
import { FormlyMatrixFieldComponent } from './formly-custom-fields/formly-matrix-field/formly-matrix-field.component';
import { FormlyCreatableSelectFieldComponent } from './formly-custom-fields/formly-creatable-select-field/formly-creatable-select-field.component';
import { FormlyLegalConditionsComponent } from './formly-custom-fields/formly-legal-conditions/formly-legal-conditions.component';
import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule,
} from 'ngx-perfect-scrollbar';
import { FormRenderComponent } from './form-render/form-render.component';
import { MatStepperModule } from '@angular/material/stepper';
import { FormlyLabelFieldComponent } from './formly-custom-fields/formly-label-field/formly-label-field.component';
import { FilterMatrixPipe } from './formly-custom-fields/formly-matrix-field/filter-matrix.pipe';
import { FormlyPostCodeFieldChildComponent } from './formly-custom-fields/formly-post-code-input-field/formly-post-code-field-child.component';
import { FormlyDocumentScanningDeviceDetectorFieldComponent } from './formly-custom-fields/formly-document-scanning-device-detector-field/formly-document-scanning-device-detector-field.component';
import { DocumentScanningComponent } from './components/document-scanning/document-scanning.component';
import { EffectsModule } from '@ngrx/effects';
import { SharedEffects } from './+state/shared.effects';
import { QRCodeModule } from 'angularx-qrcode';
import { MobileDocumentScanningComponent } from './components/mobile-document-scanning/mobile-document-scanning.component';
import { InvalidFile } from './directives/invalid-file.directive';
import { FormlyRadioFieldComponent } from './formly-custom-fields/formly-radio-field/formly-radio-field.component';
import { FormlyMultiSelectFieldComponent } from './formly-custom-fields/formly-multi-select-field/formly-multi-select-field.component';
import { FormlySelectFieldComponent } from './formly-custom-fields/formly-select-field/formly-select-field.component';
import { AreAllYSelectedPipe } from './formly-custom-fields/formly-matrix-field/are-all-y-selected.pipe';
import { RemoveHtmlTagsPipe } from './formly-custom-fields/formly-matrix-field/remove-html-tags.pipe';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true,
};

@NgModule({
  declarations: [
    FilterMatrixPipe,
    AreAllYSelectedPipe,
    RemoveHtmlTagsPipe,
    FormlyTextFieldComponent,
    DsValueAccessorDirective,
    FormlyDateFieldComponent,
    FormlyCreatableSelectFieldComponent,
    FormlyMatrixFieldComponent,
    FormlyLegalConditionsComponent,
    FormRenderComponent,
    FormlyLabelFieldComponent,
    FormlyPostCodeFieldChildComponent,
    FormlyDocumentScanningDeviceDetectorFieldComponent,
    DocumentScanningComponent,
    MobileDocumentScanningComponent,
    InvalidFile,
    FormlyRadioFieldComponent,
    FormlyMultiSelectFieldComponent,
    FormlySelectFieldComponent,
  ],
  imports: [
    PerfectScrollbarModule,
    UiModule,
    ReactiveFormsModule,
    NavigationMenuModule,
    FormsModule,
    FormlyModule,
    HttpClientModule,
    CommonModule,
    MatStepperModule,
    EffectsModule.forFeature([SharedEffects]),
    QRCodeModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  exports: [
    MatStepperModule,
    NavigationMenuModule,
    DsValueAccessorDirective,
    FormRenderComponent,
    FormlyPostCodeFieldChildComponent,
  ],
})
export class SharedModule {}
